// extracted by mini-css-extract-plugin
export default {"site":"admin-layout_site__hbg6w","main":"admin-layout_main__vtTdh"};